<template>
  <div @click="expand" class="cursor-pointer">
    <r-icon v-if='!expanded' name="expand_more" :size="size"/>
    <r-icon v-else name="expand_less" :size="size"/>
  </div>
</template>

<script>
import RIcon from '@/components/base/RIcon';

export default {
  name: 'ExpandButton',
  components: { RIcon },
  props: {
    size: {
      type: String,
      default: '12px',
    },
    externallyExpanded: Boolean,
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    expand() {
      this.expanded = !this.expanded;
      this.$emit('click', this.expanded);
    },
  },
  watch: {
    externallyExpanded(newValue) {
      this.expanded = newValue;
    },
  },
};
</script>
